import React from "react";
import {
	ListSubheader,
	List,
	ListItemButton,
	ListItemText,
	Collapse,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { groupWalletsByCategory } from "../../components/common/groupWalletsByCategory";
import { returnCategoryTranslation } from "../../pages/Manager/NettWorth/Accounts/Functions/returnCategoryTranslation";

export function FilterList({ wallets, filterParams, addFilterParams }) {
	const theme = useTheme();
	const { t } = useTranslation();
	const [openWallets, setOpenWallets] = React.useState(false);
	const [openType, setOpenType] = React.useState(false);
	const [openImportant, setOpenImportant] = React.useState(false);
	const groupedWallets = groupWalletsByCategory(wallets);

	const handleClickWallets = () => {
		setOpenWallets(!openWallets);
	};

	const handleClickType = () => {
		setOpenType(!openType);
	};

	const handleClickImportant = () => {
		setOpenImportant(!openImportant);
	};

	const listButtonStyle = {
		py: 0,
		px: 1,
		mx: 1,
		borderRadius: "10px",
	};

	const itemButtonStyle = {
		py: 0,
		px: 2,
		mx: 2,
		borderRadius: "10px",
	};

	return (
		<List
			sx={{
				borderRadius: "20px",
				width: 300,
				bgcolor: theme.palette.background.paper,
			}}
			aria-labelledby="nested-list-subheader"
			subheader={
				<ListSubheader id="nested-list-subheader">
					{t("filterTransactions")}
				</ListSubheader>
			}
		>
			<ListItemButton onClick={handleClickWallets} sx={listButtonStyle}>
				<ListItemText primary={t("wallets")} />
				{openWallets ? <ExpandLess /> : <ExpandMore />}
			</ListItemButton>
			<Collapse in={openWallets} timeout="auto" unmountOnExit>
				{Object.entries(groupedWallets).map(([category, items]) => (
					<List disablePadding key={category}>
						<ListSubheader
							sx={{
								lineHeight: "1.5",
								fontWeight: "bold",
								ml: 1,
							}}
						>
							{returnCategoryTranslation(t, category)}
						</ListSubheader>
						{items.map((wallet) => (
							<ListItemButton
								key={wallet._id}
								sx={itemButtonStyle}
								onClick={() =>
									addFilterParams("walletFilters", wallet._id)
								}
							>
								<ListItemText primary={wallet.name} />
							</ListItemButton>
						))}
					</List>
				))}
			</Collapse>

			<ListItemButton onClick={handleClickType} sx={listButtonStyle}>
				<ListItemText primary={t("type")} />
				{openType ? <ExpandLess /> : <ExpandMore />}
			</ListItemButton>
			<Collapse in={openType} timeout="auto" unmountOnExit>
				<List disablePadding>
					<ListItemButton
						sx={itemButtonStyle}
						onClick={() => addFilterParams("typeFilters", "income")}
					>
						<ListItemText primary={t("income")} />
					</ListItemButton>
					<ListItemButton
						sx={itemButtonStyle}
						onClick={() =>
							addFilterParams("typeFilters", "expense")
						}
					>
						<ListItemText primary={t("expense")} />
					</ListItemButton>
				</List>
			</Collapse>

			<ListItemButton onClick={handleClickImportant} sx={listButtonStyle}>
				<ListItemText primary={t("important")} />
				{openImportant ? <ExpandLess /> : <ExpandMore />}
			</ListItemButton>
			<Collapse in={openImportant} timeout="auto" unmountOnExit>
				<List disablePadding>
					<ListItemButton
						sx={itemButtonStyle}
						onClick={() =>
							addFilterParams("importantFilters", "important")
						}
					>
						<ListItemText primary={t("showImportant")} />
					</ListItemButton>
					<ListItemButton
						sx={itemButtonStyle}
						onClick={() =>
							addFilterParams("importantFilters", "unimportant")
						}
					>
						<ListItemText primary={t("showUnimportant")} />
					</ListItemButton>
				</List>
			</Collapse>
		</List>
	);
}
